import { render } from "./SingleSignOn.vue?vue&type=template&id=fc49f93e"
import script from "./SingleSignOn.vue?vue&type=script&lang=js"
export * from "./SingleSignOn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__